<template>
  <div class="transactions-section" v-loading="isLoading">
    <div class="section-header">
      <h3 class="section-title">Practice View Transactions</h3>
      <div class="header-actions">
        <ResponsiveButton
          v-component-loading="exportingBatch"
          size="medium"
          display_name = "Export CSV"
          button_type = "outlined"
          :disabled="exportingBatch"
          @click-button="exportTransactions"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M4.5 6H6.5V9H16.5V6H18.5V12H20.5V6C20.5 4.9 19.6 4 18.5 4H14.32C13.9 2.84 12.8 2 11.5 2C10.2 2 9.1 2.84 8.68 4H4.5C3.4 4 2.5 4.9 2.5 6V20C2.5 21.1 3.4 22 4.5 22H9.5V20H4.5V6ZM11.5 4C12.05 4 12.5 4.45 12.5 5C12.5 5.55 12.05 6 11.5 6C10.95 6 10.5 5.55 10.5 5C10.5 4.45 10.95 4 11.5 4Z" fill="#374957"/>
              <path d="M17.51 14L16.09 15.41L17.67 16.99H11.5V18.99H17.67L16.09 20.58L17.51 21.99L21.5 17.99L17.51 14Z" fill="#374957"/>
            </svg>
          </template>
        </ResponsiveButton>
        <!-- <Button
          color-type="dark-blue-stroke"
          @click="exportTransactions"
          :disabled="exportingBatch"
          :loading="exportingBatch"
        >
          <div style="display: flex; align-items: center; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M4.5 6H6.5V9H16.5V6H18.5V12H20.5V6C20.5 4.9 19.6 4 18.5 4H14.32C13.9 2.84 12.8 2 11.5 2C10.2 2 9.1 2.84 8.68 4H4.5C3.4 4 2.5 4.9 2.5 6V20C2.5 21.1 3.4 22 4.5 22H9.5V20H4.5V6ZM11.5 4C12.05 4 12.5 4.45 12.5 5C12.5 5.55 12.05 6 11.5 6C10.95 6 10.5 5.55 10.5 5C10.5 4.45 10.95 4 11.5 4Z" fill="#374957"/>
              <path d="M17.51 14L16.09 15.41L17.67 16.99H11.5V18.99H17.67L16.09 20.58L17.51 21.99L21.5 17.99L17.51 14Z" fill="#374957"/>
            </svg>
            <span>Export CSV</span>
          </div>
        </Button> -->
        <ResponsiveButton
          v-component-loading="downloadingBatch"
          size="medium"
          display_name = "Download Batch"
          button_type = "filled"
          built_in_theme = "light"
          :disabled="checkedIds.length === 0 || downloadingBatch"
          @click-button="handleDownloadBatch"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" fill="white"/>
            </svg>
          </template>
        </ResponsiveButton>
        <!-- <Button
          color-type="sky-blue"
          :disabled="checkedIds.length === 0 || downloadingBatch"
          :loading="downloadingBatch"
          @click="handleDownloadBatch"
        >
          <div style="display: flex; align-items: center; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" fill="white"/>
            </svg>
            <span>Download Batch</span>
          </div>
        </Button> -->
      </div>
    </div>

    <div class="search-filter-row">
      <div class="control-group">
        <Label label="Search">
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#4A4A4A">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </template>
          <TextInput 
          v-model="searchQuery"
          type="text"
          placeholder="Search" 
          @input="onSearchDebounced"
          />
        </Label>
        <!-- <label class="control-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#4A4A4A">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <span>Search</span>
        </label>
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Search"
          class="search-input"
          @input="onSearchDebounced"
        /> -->
      </div>
      <div class="control-group">
        <Label label="Payer">
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="#374957"/>
            </svg>
          </template>
          <SingleSelector
            v-model="filterPayer"
            :options="payerOptions" 
            size="medium" 
            @change="onPayerSelected"/>
        </Label>
        <!-- <label class="control-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="#374957"/>
          </svg>
          <span>Payer</span>
        </label>
        <SimpleSelector
          v-model:currentElementType="filterPayer"
          :elements="payerOptions"
          class="filter-select"
          @element-selected="onPayerSelected"
        /> -->
      </div>
      <div class="control-group">
        <Label label="Transaction Method">
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#374957"/>
            </svg>
          </template>
          <SingleSelector
            v-model="filterMethod"
            :options="paymentMethodOptions" 
            size="medium" 
            @change="onMethodSelected"/>
        </Label>
        <!-- <label class="control-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#374957"/>
          </svg>
          <span>Transaction Method</span>
        </label>
        <SimpleSelector
          v-model:currentElementType="filterMethod"
          :elements="paymentMethodOptions"
          class="filter-select"
          @element-selected="onMethodSelected"
        /> -->
      </div>
      <div class="control-group">
        <Label label="Time Range">
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M7 11H9V13H7V11ZM21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19ZM15 13H17V11H15V13ZM11 13H13V11H11V13Z" fill="#374957"/>
            </svg>
          </template>
          <SingleSelector
            v-if="!showDatePicker"
            v-model="filterTimeRange"
            :options="timeRangeOptions"
            size="medium"
          />
          <el-date-picker
            v-else
            style = "width: 100%"
            v-model="customDateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="Start Date"
            end-placeholder="End Date"
            size="default"
            format="MMM DD, YYYY"
            value-format="YYYY-MM-DDTHH:mm:ss.SSSZ"
            :disabledDate="disableFutureDates"
            @change="onCustomDateChange"
          />
        </Label>
        <!-- <label class="control-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7 11H9V13H7V11ZM21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19ZM15 13H17V11H15V13ZM11 13H13V11H11V13Z" fill="#374957"/>
          </svg>
          <span>Time Range</span>
        </label>
        <SimpleSelector
          v-if="!showDatePicker"
          v-model:currentElementType="filterTimeRange"
          :elements="timeRangeOptions"
          class="filter-select"
          @element-selected="onTimeRangeSelected"
        />
        <el-date-picker
          v-else
          v-model="customDateRange"
          type="daterange"
          range-separator="-"
          start-placeholder="Start Date"
          end-placeholder="End Date"
          size="default"
          format="MMM DD, YYYY"
          value-format="YYYY-MM-DDTHH:mm:ss.SSSZ"
          class="filter-select"
          :disabledDate="disableFutureDates"
          @change="onCustomDateChange"
        /> -->
      </div>
    </div>

    <div class="transactions-table">
      <div class="table-header">
        <div class="th-cell checkbox-col">
          <Checkbox
            :status="checkAllStatus"
            :isAll="true"
            @changeStatus="toggleSelectAll"
          />
        </div>
        <div class="th-cell date-col">Date & Time</div>
        <div class="th-cell id-col">Transaction ID</div>
        <div class="th-cell payer-col">Payer</div>
        <div class="th-cell amount-col">Amount</div>
        <div class="th-cell method-col">Transaction Method</div>
        <div class="th-cell status-col">Status</div>
        <div class="th-cell actions-col">Actions</div>
      </div>

      <div v-if="!transactions.length" class="table-empty">
        No transactions found.
      </div>

      <div class="transactions-data-container">
        <div
          v-for="txn in transactions"
          :key="txn.id || txn.record_id"
          class="table-row"
        >
          <div class="td-cell checkbox-col">
            <Checkbox
              :status="checkedIds.includes(txn.id || txn.record_id) ? 'checked' : 'uncheck'"
              @changeStatus="(status) => toggleCheck(txn.id || txn.record_id, status)"
            />
          </div>
          <div class="td-cell date-col">{{ formatDateTime(txn.event_time) }}</div>
          <div class="td-cell id-col">{{ txn.record_id }}</div>
          <div v-if="txn.transaction_type !== 'refund'" class="td-cell payer-col">
            <span class="payer-name">{{ txn.payer_name || '—' }}</span>
            <span class="payer-role">{{ txn.payer_type || '' }}</span>
          </div>
          <div v-else class="td-cell payer-col">
            <span class="payer-name">Vibrant</span>
            <span class="payer-role">System</span>
          </div>
          <div class="td-cell amount-col">{{ txn.transaction_type === 'refund' ? '-' : '' }}${{ formatAmount(txn.amount) }}</div>
          <div class="td-cell method-col">{{ getPaymentMethodLabel(txn.payment_method) || '—' }}</div>
          <div class="td-cell status-col">
            <span class="status-chip" :class="statusClass(txn.status)">{{ formatStatus(txn.status) }}</span>
          </div>
          <div class="td-cell actions-col" v-loading = "exportingTxnId === txn.record_id">
            <FoldableButton 
              text="Download"
              built_in_theme="default"
              @click="handleExportSingleTransaction(txn.record_id)"
              :transition_duration="0.5"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM12.75 8.25L11.6925 7.1925L9.75 9.1275V3H8.25V9.1275L6.3075 7.1925L5.25 8.25L9 12L12.75 8.25Z" fill="#1F1F1F"/>
                </svg>
              </template>
            </FoldableButton>
            <!-- <ActionButton
              text="Download"
              default-color="#374957"
              hover-text-color="#1E4670"
              pressed-text-color="#1E4670"
              hover-bg-color="rgba(30, 70, 112, 0.08)"
              pressed-bg-color="rgba(30, 70, 112, 0.12)"
              @click.stop="handleExportSingleTransaction(txn.record_id)"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM12.75 8.25L11.6925 7.1925L9.75 9.1275V3H8.25V9.1275L6.3075 7.1925L5.25 8.25L9 12L12.75 8.25Z" fill="#1F1F1F"/>
                </svg>
              </template>
            </ActionButton> -->
          </div>
        </div>
      </div>
      
    </div>

    <div v-if="totalCount > 0" class="table-pagination">
      <Pagination
        v-model:current_page="currentPage"
        v-model:per_page="pageSize"
        :total_items="totalCount"
        :per_page_options="[10, 20, 50]"
        item_label="results"
        :show_summary="false"
      />
      <!-- <MedicationPagination
        :total="totalCount"
        :pageSize="pageSize"
        :currentPage="currentPage"
        :pageSizeOptions="[10, 20, 50]"
        @page-change="handlePageChange"
        @page-size-change="handlePageSizeChange"
      /> -->
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import MedicationPagination from '@/NewLibrary/MedicationPagination.vue';
import SimpleSelector from '@/views/commonComponents/SimpleSelector.vue';
import Button from '@/NewLibrary/Button.vue';
import ActionButton from '@/views/commonComponents/ActionButton.vue';
import Checkbox from '@/NewLibrary/Checkbox.vue';

const store = useStore();
let searchTimer = null;

const exportingTxnId = ref(null);
const exportingBatch = ref(false);
const downloadingBatch = ref(false);

const isLoading = computed(() => store.state.myPractice.clinicDashboard.transactionsTableLoading);
const transactions = computed(() => store.getters['myPractice/clinicDashboard/transactionsTableData']);
const totalCount = computed(() => store.getters['myPractice/clinicDashboard/transactionsTableTotal']);
const checkedIds = computed(() => store.state.myPractice.clinicDashboard.checkedTransactionIds);

const searchQuery = ref('');
const filterTimeRange = ref('last_30_days');
const filterPayer = ref('all');
const filterMethod = ref('all');
const customDateRange = ref(null);
const showDatePicker = ref(false);
const currentPage = ref(1);
const pageSize = ref(store.state.myPractice.clinicDashboard.transactionsTableFilters.pageSize || 10);

// Guard to prevent watch from firing during programmatic restore
let isRestoringFilters = false;

// Restore filters from store on mount
onMounted(() => {
  isRestoringFilters = true;
  const filters = store.state.myPractice.clinicDashboard.transactionsTableFilters;

  // Restore search query
  if (filters.search) {
    searchQuery.value = filters.search;
  }

  // Restore payer filter
  if (filters.payerType) {
    filterPayer.value = filters.payerType;
  } else if (filters.transactionType === 'refund') {
    filterPayer.value = 'system';
  } else {
    filterPayer.value = 'all';
  }

  // Restore payment method filter
  if (filters.paymentMethod) {
    filterMethod.value = filters.paymentMethod;
  } else {
    filterMethod.value = 'all';
  }

  // Restore time range and custom dates
  if (filters.timeRange) {
    if (filters.timeRange === 'custom' && filters.startDate && filters.endDate) {
      customDateRange.value = [filters.startDate, filters.endDate];
      filterTimeRange.value = `custom_${filters.startDate}_${filters.endDate}`;
      showDatePicker.value = false;
    } else {
      filterTimeRange.value = filters.timeRange;
    }
  }
  nextTick(() => { isRestoringFilters = false; });
});

// const currentPage = computed(() => store.state.myPractice.clinicDashboard.transactionsTableFilters.page);
// const pageSize = computed(() => store.state.myPractice.clinicDashboard.transactionsTableFilters.pageSize);

const customRangeLabel = computed(() => {
  if (customDateRange.value && customDateRange.value.length === 2) {
    const startDate = new Date(customDateRange.value[0]);
    const endDate = new Date(customDateRange.value[1]);
    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      return `${month}/${day}/${year}`;
    };
    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }
  return 'Custom Range';
});

const customRangeKey = computed(() => {
  if (customDateRange.value && customDateRange.value.length === 2) {
    return `custom_${customDateRange.value[0]}_${customDateRange.value[1]}`;
  }
  return null;
});

const timeRangeOptions = computed(() => {
  const options = [
    { value: 'last_7_days', label: 'Last 7 Days', iconSvg: '' },
    { value: 'last_30_days', label: 'Last 30 Days', iconSvg: '' },
    { value: 'last_90_days', label: 'Last 90 Days', iconSvg: '' },
    { value: 'last_year', label: 'Last Year', iconSvg: '' },
  ];
  if (customRangeKey.value) {
    options.push({ value: customRangeKey.value, label: customRangeLabel.value, iconSvg: '' });
  }
  options.push({ value: 'custom', label: 'Custom Range', iconSvg: '' });
  return options;
});

watch(() => filterTimeRange.value, (val) => {
  if (isRestoringFilters) return;
  if (val === 'custom') {
    showDatePicker.value = true;
    return;
  }
  // Custom key changes are handled by onCustomDateChange
  if (typeof val === 'string' && val.startsWith('custom_')) {
    return;
  }
  showDatePicker.value = false;
  customDateRange.value = null;
  updateFiltersAndFetch(true);
});

const payerOptions = [
  { value: 'all', label: 'All Payers', iconSvg: '' },
  { value: 'patient', label: 'Patient', iconSvg: '' },
  { value: 'customer', label: 'Provider', iconSvg: '' },
  { value: 'clinic', label: 'Clinic', iconSvg: '' },
  { value: 'system', label: 'System', iconSvg: '' }
];

const paymentMethodOptions = [
  { value: 'all', label: 'All Transaction Methods', iconSvg: '' },
  { value: 'ach', label: 'ACH', iconSvg: '' },
  { value: 'card', label: 'Card', iconSvg: '' },
  { value: 'credit', label: 'Credit', iconSvg: '' },
  { value: 'klarna', label: 'Klarna', iconSvg: '' },
  { value: 'afterpay_clearpay', label: 'Afterpay Clearpay', iconSvg: '' }
];

const isAllChecked = computed(() =>
  transactions.value.length > 0 && transactions.value.every((t) => checkedIds.value.includes(t.id || t.record_id))
);
const isIndeterminate = computed(() =>
  checkedIds.value.length > 0 && !isAllChecked.value
);

const checkAllStatus = computed(() => {
  if (transactions.value.length === 0) return 'uncheck';
  if (isAllChecked.value) return 'checked';
  if (checkedIds.value.length > 0) return 'partial';
  return 'uncheck';
});

function toggleSelectAll(status) {
  if (status === 'checked') {
    const ids = transactions.value.map((t) => t.id || t.record_id);
    store.commit('myPractice/clinicDashboard/SET_CHECKED_TRANSACTION_IDS', ids);
  } else {
    store.commit('myPractice/clinicDashboard/SET_CHECKED_TRANSACTION_IDS', []);
  }
}

function toggleCheck(id, status) {
  const current = [...checkedIds.value];
  if (status === 'checked') {
    if (!current.includes(id)) {
      current.push(id);
    }
  } else {
    const idx = current.indexOf(id);
    if (idx > -1) {
      current.splice(idx, 1);
    }
  }
  store.commit('myPractice/clinicDashboard/SET_CHECKED_TRANSACTION_IDS', current);
}

// ========================================================================
// Filter Helper Functions
// ========================================================================

function formatDateToISO(date) {
  return date ? moment(date).utc().toISOString() : null;
}

function buildFilterParams(resetPage = false) {
  return {
    search: searchQuery.value,
    timeRange: typeof filterTimeRange.value === 'string' && filterTimeRange.value.startsWith('custom_') ? 'custom' : filterTimeRange.value,
    startDate: formatDateToISO(customDateRange.value?.[0]),
    endDate: formatDateToISO(customDateRange.value?.[1]),
    payerType: filterPayer.value === 'all' ? '' : (filterPayer.value === 'system' ? '' : filterPayer.value),
    transactionType: filterPayer.value === 'system' ? 'refund' : '',
    paymentMethod: filterMethod.value === 'all' ? '' : filterMethod.value,
    page: resetPage ? 1 : currentPage.value,
    pageSize: pageSize.value
  };
}

async function updateFiltersAndFetch(resetPage = false) {
  const filters = buildFilterParams(resetPage);
  await store.commit('myPractice/clinicDashboard/SET_TRANSACTIONS_TABLE_FILTERS', filters);
  await store.dispatch('myPractice/clinicDashboard/fetchTransactionsData');
}

// ========================================================================
// Search & Filter Handlers
// ========================================================================

function onSearchDebounced() {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    updateFiltersAndFetch(true);
  }, 400);
}
watch(currentPage, (newPage) => {
  store.commit('myPractice/clinicDashboard/SET_TRANSACTIONS_TABLE_FILTERS', { page: newPage });
  store.dispatch('myPractice/clinicDashboard/fetchTransactionsData');
});

watch(pageSize, (newPageSize) => {
  store.commit('myPractice/clinicDashboard/SET_TRANSACTIONS_TABLE_FILTERS', { 
    pageSize: newPageSize,
    page: 1
  });
  store.dispatch('myPractice/clinicDashboard/fetchTransactionsData');
})

// function handlePageChange(newPage) {
//   store.commit('myPractice/clinicDashboard/SET_TRANSACTIONS_TABLE_FILTERS', { page: newPage });
//   store.dispatch('myPractice/clinicDashboard/fetchTransactionsData');
// }

// function handlePageSizeChange(newPageSize) {
//   store.commit('myPractice/clinicDashboard/SET_TRANSACTIONS_TABLE_FILTERS', { 
//     pageSize: newPageSize,
//     page: 1
//   });
//   store.dispatch('myPractice/clinicDashboard/fetchTransactionsData');
// }

function onCustomDateChange(val) {
  if (val && val.length === 2) {
    showDatePicker.value = false;
    customDateRange.value = val;
    filterTimeRange.value = `custom_${val[0]}_${val[1]}`;
    updateFiltersAndFetch(true);
  }
}

function disableFutureDates(date) {
  return date > new Date();
}

function onPayerSelected(element) {
  filterPayer.value = element.value;
  updateFiltersAndFetch(true);
}

function onMethodSelected(element) {
  filterMethod.value = element.value;
  updateFiltersAndFetch(true);
}

// ========================================================================
// Export Handlers
// ========================================================================
async function handleExportSingleTransaction(recordId) {
  exportingTxnId.value = recordId;
  try {
    await store.dispatch('myPractice/clinicDashboard/exportTransactions', { 
      selectedIds: [recordId] 
    });
  } catch (error) {
    console.error('Export failed:', error);
  } finally {
    exportingTxnId.value = null;
  }
}

async function exportTransactions() {
  exportingBatch.value = true;
  try {
    await store.dispatch('myPractice/clinicDashboard/exportTransactions');
  } catch (error) {
    console.error('Export failed:', error);
  } finally {
    exportingBatch.value = false;
  }
}

async function handleDownloadBatch() {
  if (checkedIds.value.length === 0) return;
  downloadingBatch.value = true;
  try {
    await store.dispatch('myPractice/clinicDashboard/exportTransactions', {
      selectedIds: checkedIds.value
    });
  } catch (error) {
    console.error('Download batch failed:', error);
  } finally {
    downloadingBatch.value = false;
  }
}

// ========================================================================
// Formatting Utilities
// ========================================================================

function formatDateTime(dateStr) {
  if (!dateStr) return '—';
  return moment(dateStr).format('MMM-DD-YYYY, HH:mm');
}

function formatAmount(val) {
  if (val == null) return '0.00';
  return Number(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function getPaymentMethodLabel(method) {
  if (!method) return '—';
  const labelMap = {
    'ach': 'ACH',
    'card': 'Card',
    'credit': 'Credit',
    'klarna': 'Klarna',
    'afterpay_clearpay': 'Afterpay Clearpay'
  };
  return labelMap[method] || method;
}

function formatStatus(status) {
  if (!status) return '—';
  const s = status.toLowerCase();
  if (s === 'completed' || s === 'success') return 'Completed';
  if (s === 'pending') return 'Pending';
  if (s === 'failed' || s === 'error') return 'Failed';
  return status;
}

function statusClass(status) {
  if (!status) return '';
  const s = status.toLowerCase();
  if (s === 'completed' || s === 'succeed') return 'status-completed';
  if (s === 'pending') return 'status-pending';
  if (s === 'failed' || s === 'error') return 'status-failed';
  return '';
}
</script>

<style scoped>
.transactions-section {
  background: #F9FBFD;
  border-radius: 10px;
  padding: 16px 24px;
  max-height: 708px;
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.section-title {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #333;
  margin: 0;
  flex: 1;
}

.header-actions {
  display: flex;
  gap: 8px;
}


.search-filter-row {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 0;
  min-width: 0;
}

.control-label {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
}

.control-label svg {
  width: 24px;
  height: 24px;
}

.search-input {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  background: white;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
}

.search-input::placeholder {
  color: #999;
}

.search-input:focus {
  outline: none;
  border-color: #004879;
}

.filter-select {
  width: 100%;
}

.transactions-table {
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 15px 0 rgba(164, 164, 164, 0.25);
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: #FDF9F6;
  border-bottom: 1px solid #C4C4C4;
}

.th-cell {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #666;
  text-align: center;
}

.th-cell.checkbox-col,
.th-cell.date-col {
  text-align: left;
}
.transactions-data-container {
  flex: 1;
  overflow-y: auto;
}
.table-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #C4C4C4;
  transition: background 0.15s;
}

.table-row:hover {
  background: #F9FBFD;
}

.table-row:last-child {
  border-bottom: none;
}

.td-cell {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
  text-align: center;
  white-space: pre-wrap;
  word-break: break-all;
}

.td-cell.checkbox-col,
.td-cell.date-col {
  text-align: left;
}

.checkbox-col { width: 28px; flex-shrink: 0; }
.date-col { flex: 1; min-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.id-col { flex: 1; min-width: 100px; }
.payer-col { flex: 1; min-width: 140px; }
.amount-col { flex: 1; min-width: 100px; }
.method-col { flex: 1; min-width: 140px; }
.status-col { flex: 1; min-width: 120px; display: flex; justify-content: center; }
.actions-col { width: 114px; flex-shrink: 0; text-align: center; display: flex; justify-content: center; }

.th-cell.id-col,
.th-cell.payer-col,
.th-cell.amount-col,
.th-cell.method-col,
.th-cell.status-col,
.th-cell.actions-col {
  border-left: 1px solid #C4C4C4;
}

.payer-name {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.payer-role {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #666;
  text-transform: capitalize;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  border-radius: 20px;
}

.status-completed {
  background: #E5F9EF;
  color: #25B8C2;
}

.status-pending {
  background: #FEF9E9;
  color: #F06539;
}

.status-failed {
  background: #FAEAEA;
  color: #D10000;
}

.action-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  width: 26px;
  height: 26px;
}

.action-icon-btn:hover {
  background: rgba(0, 72, 121, 0.08);
}

.action-icon-btn svg {
  width: 18px;
  height: 18px;
}

.table-empty {
  text-align: center;
  color: #9CA3AF;
  padding: 32px 0;
  font-size: 14px;
}

.table-pagination {
  padding: 16px 0 0;
}

/* SingleSelector styles - same as ez-bill */
.transactions-section :deep(.new-libary-single-selector .el-select__wrapper) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
  min-height: 40px !important;
}

.transactions-section :deep(.new-libary-single-selector .el-select__wrapper:hover),
.transactions-section :deep(.new-libary-single-selector .el-select__wrapper.is-focus) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
}
</style>
